import { RestResponse } from '../types/response/RestResponse';
import { ProjectDeliveryZoneSettings, ProjectDetails, ProjectSettings } from '../state/project/types';
import service from './RestService';
import { ProjectDetailsRequest } from '../types/services/ProjectDetailsRequest';

const path = '/projects';

class ProjectSettingsService {
  getProjectDetails = (projectId: number): RestResponse<ProjectDetails> => service.get(`${path}/${projectId}/details`);

  saveProjectDetails = (projectDetails: ProjectDetailsRequest, projectId: number): RestResponse<ProjectDetails> =>
    service.post(`${path}/${projectId}/details`, projectDetails);

  getProjectSettings = (projectId: number): RestResponse<ProjectSettings> => service.get(`${path}/${projectId}/delivery-settings`);

  saveProjectSettings = (projectId: number, projectSettings: ProjectSettings): RestResponse<ProjectSettings> =>
    service.post(`${path}/${projectId}/delivery-settings`, projectSettings);

  getDeliveryZoneSettings = (projectId: number): RestResponse<ProjectDeliveryZoneSettings> =>
    service.get(`${path}/${projectId}/delivery-zone-settings`);
}

export default new ProjectSettingsService();
